import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import optimizeImage from '@/services/ImageOptimize';
export default defineComponent({
    name: 'image-gallery-desktop-slider',
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    data: () => ({
        currentSlide: 0,
    }),
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })), { allImages() {
            if (this.currentProduct === null) {
                return [];
            }
            const images = [];
            images.push(this.currentProduct.mainImage);
            this.currentProduct.images.forEach((src) => {
                src = src.replace('thumbnail_images', 'original_images').replace('popup_images', 'original_images');
                images.push(src);
            });
            return images;
        },
        thumbnailQuantity() {
            var _a, _b;
            if (((_a = this.currentProduct) === null || _a === void 0 ? void 0 : _a.images.length) <= 2) {
                return 3;
            }
            if (((_b = this.currentProduct) === null || _b === void 0 ? void 0 : _b.images.length) > 2) {
                return 4;
            }
            return 5;
        } }),
    methods: {
        optimizeImage,
        slideTo(val) {
            this.currentSlide = val;
        },
        triggerFancyBox() {
            const gallery = this.allImages.map((image) => {
                const full = image
                    .replace('popup_images', 'original_images')
                    .replace('thumbnail_images', 'original_images');
                const thumb = optimizeImage(image, 400);
                return {
                    src: full,
                    thumb: thumb,
                };
            });
            Fancybox.show(gallery, {
                on: {
                    'Carousel.ready': (fancyBox) => {
                        fancyBox.jumpTo(this.currentSlide);
                    },
                },
            });
        },
    },
});
